import {computed, makeObservable, observable} from 'mobx';

import {BaseModel} from '../../Base/Base.model';
import {ProgramDurationUnitModel} from './ProgramDurationUnit.model';

const ModelName = 'ProgramDurationModel';

export class ProgramDurationModel extends BaseModel {
  constructor(public value: number) {
    super({
      id: '',
    });

    makeObservable<ProgramDurationModel>(this, {
      num: computed,
      unit: computed,
      value: observable,
    });
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }

  get num(): number {
    return this.value / this.unit.multiplier;
  }

  get unit(): ProgramDurationUnitModel {
    return ProgramDurationUnitModel.detect(this.value);
  }

  format(
    {isDashed, isSingular}: ProgramDurationModel.FormatOptions = {
      isDashed: false,
      isSingular: false,
    },
  ): string {
    const result = `${this.num} ${this.unit.format(this.num, {isSingular})}`;

    if (isDashed) {
      return result.replace(/\s+/g, '-');
    }

    return result;
  }
}

export namespace ProgramDurationModel {
  export type FormatOptions = {
    isDashed?: boolean;
    isSingular?: boolean;
  };

  export type Props = BaseModel.ModelToProps<ProgramDurationModel>;
}
